<div class="w-full animate-fade-in pb-10  relative">
    <!-- Header Shared Component -->
    <app-section-header [title]="isEdit() ? 'Editar Módulo' : 'Nuevo Módulo'"
        [description]="'Módulos del Sistema' +' | ' + (isEdit() ? 'Editar' : 'Crear Nuevo')" icon="mdi:puzzle-outline"
        [showBack]="true">
    </app-section-header>

    <form [formGroup]="form" class="animate-fade-in">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <!-- COL 1: Identidad + Sidebar -->
            <div class="space-y-4">
                <!-- Sección: Identidad -->
                <div class="compact-section space-y-4">
                    <p
                        class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                        <iconify-icon icon="mdi:information-outline" width="13" class="text-primary"></iconify-icon>
                        Identidad Técnica
                    </p>

                    <!-- Key -->
                    <div>
                        <app-input label="Key del Módulo" formControlName="key" size="sm" icon="mdi:key-variant"
                            [required]="true" inputClass="font-bold" [readonly]="isEdit()"
                            placeholder="patients, sales..." [error]="keyError">
                        </app-input>
                        <div *ngIf="form.get('key')?.value"
                            class="mt-1 px-2.5 py-1.5 bg-foreground/[0.02] border border-foreground/[0.05] rounded-lg flex items-center gap-2">
                            <iconify-icon icon="mdi:key-outline" width="11"
                                class="text-primary/75 flex-shrink-0"></iconify-icon>
                            <code
                                class="text-[9px] text-foreground/70">{{ form.get('key')?.value }}:list · {{ form.get('key')?.value }}:create ···</code>
                        </div>
                    </div>

                    <!-- Label + Icono en 2 cols -->
                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Nombre" formControlName="label" size="sm" icon="mdi:tag-outline"
                            [required]="true" placeholder="Pacientes" [error]="fieldError('label')"></app-input>

                        <div>
                            <app-input label="Ícono MDI" formControlName="icon" size="sm" icon="mdi:palette-outline"
                                [required]="true" inputClass="font-bold" placeholder="mdi:tooth-outline"
                                [error]="fieldError('icon')"></app-input>
                            <div *ngIf="form.get('icon')?.value" class="mt-1 flex items-center gap-2">
                                <div
                                    class="w-7 h-7 flex-shrink-0 bg-primary/[0.08] rounded-lg flex items-center justify-center border border-primary/[0.12]">
                                    <iconify-icon [attr.icon]="form.get('icon')?.value" width="15"
                                        class="text-primary/70"></iconify-icon>
                                </div>
                                <a href="https://icon-sets.iconify.design/mdi/" target="_blank"
                                    class="text-[8px] text-foreground/45 underline hover:text-foreground/50">iconify.design/mdi</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Sección: Sidebar & Ruta -->
                <div class="compact-section space-y-4">
                    <p
                        class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                        <iconify-icon icon="mdi:dock-left" width="13" class="text-primary"></iconify-icon>
                        Sidebar &amp; Ruta
                    </p>

                    <div class="grid grid-cols-2 gap-3">
                        <app-input label="Ruta Angular" formControlName="route" size="sm" icon="mdi:routes"
                            [required]="true" placeholder="/app/patients" [error]="fieldError('route')"></app-input>

                        <app-select label="Grupo del Menú" formControlName="group" size="sm" icon="mdi:folder-outline"
                            [options]="groupOptions()" [fullWidth]="true"></app-select>
                    </div>

                    <div class="grid grid-cols-2 gap-3 items-end">
                        <app-input label="Orden" formControlName="order" type="number" size="sm"
                            icon="mdi:sort-numeric-ascending" placeholder="10"></app-input>

                        <!-- Toggle isActive -->
                        <label class="flex items-center justify-between cursor-pointer py-1.5 group">
                            <div>
                                <span
                                    class="text-[9px] font-black uppercase tracking-widest text-foreground/65 block">Activo</span>
                                <span class="text-[8px] text-foreground/45">Visible para negocios</span>
                            </div>
                            <div class="relative">
                                <input type="checkbox" formControlName="isActive" class="sr-only peer">
                                <div class="w-9 h-5 bg-foreground/10 rounded-full
                                              peer peer-checked:bg-primary
                                              after:content-[''] after:absolute after:top-[3px] after:left-[3px]
                                              after:bg-white after:rounded-full after:h-3.5 after:w-3.5
                                              after:transition-all peer-checked:after:translate-x-4">
                                </div>
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <!-- COL 2: Permisos -->
            <div class="compact-section space-y-4 flex flex-col">
                <div class="flex items-center justify-between">
                    <p
                        class="flex items-center gap-2 text-[9px] font-black uppercase tracking-[0.22em] text-foreground/60">
                        <iconify-icon icon="mdi:shield-key-outline" width="13" class="text-primary"></iconify-icon>
                        Permisos del Módulo
                        <span class="ml-1 px-1.5 py-0.5 bg-foreground/[0.05] rounded-md text-emerald-500 font-black">
                            {{ permissionsArray.length }}
                        </span>
                    </p>
                    <button type="button" (click)="addCommonActions()" *ngIf="form.get('key')?.value" class="flex items-center gap-1 text-[8px] font-black uppercase tracking-widest
                                       text-primary hover:text-primary transition-colors
                                       px-2 py-1 rounded-lg hover:bg-primary/10">
                        <iconify-icon icon="mdi:auto-fix" width="11"></iconify-icon>
                        Auto CRUD
                    </button>
                </div>

                <!-- Chips de acciones comunes -->
                <div *ngIf="form.get('key')?.value">
                    <p class="text-[8px] font-black uppercase tracking-widest text-foreground/45 mb-2">Acciones
                        sugeridas</p>
                    <div class="flex flex-wrap gap-1.5">
                        <button type="button" *ngFor="let action of commonActionsMetadata()"
                            class="px-2 py-1 rounded text-[8px] font-black uppercase border transition-all flex items-center gap-1"
                            [class.bg-primary/10]="isPermSelected(action.key)"
                            [class.border-primary/20]="isPermSelected(action.key)"
                            [class.text-primary]="isPermSelected(action.key)"
                            [class.bg-foreground/[0.02]]="!isPermSelected(action.key)"
                            [class.border-transparent]="!isPermSelected(action.key)"
                            [class.text-foreground/45]="!isPermSelected(action.key)" (click)="toggleAction(action.key)">
                            <iconify-icon [attr.icon]="action.icon" width="10"></iconify-icon>
                            {{ action.label }}
                        </button>
                    </div>
                </div>

                <!-- Permiso personalizado -->
                <div class="flex gap-2 items-center pt-1 border-t border-foreground/[0.04]">
                    <input #customPermInput [placeholder]="(form.get('key')?.value || 'module') + ':accion'" class="flex-1 min-w-0 px-3 py-1.5 bg-foreground/[0.03] border border-foreground/[0.06]
                                      rounded-xl text-xs font-bold focus:outline-none focus:ring-1
                                      focus:ring-primary/30 focus:border-primary/50 transition-all font-black"
                        (keydown.enter)="addCustom(customPermInput.value); customPermInput.value = ''">
                    <app-button type="button" variant="outline" size="xs" iconLeft="mdi:plus"
                        (click)="addCustom(customPermInput.value); customPermInput.value = ''">
                        Agregar
                    </app-button>
                </div>

                <!-- Lista permisos configurados -->
                <div class="flex-1 overflow-y-auto space-y-1 pt-1 border-t border-foreground/[0.04] min-h-[200px]">
                    <p class="text-[8px] font-black uppercase tracking-widest text-foreground/45 mb-1.5">Matriz Actual
                    </p>

                    <div *ngIf="permissionsArray.length === 0"
                        class="py-12 flex flex-col items-center gap-2 opacity-30">
                        <iconify-icon icon="mdi:shield-lock-outline" width="28"
                            class="text-foreground/45"></iconify-icon>
                        <p class="text-[9px] font-black uppercase tracking-widest">Sin permisos registrados</p>
                    </div>

                    <div *ngFor="let ctrl of permissionsArray.controls; let i = index" class="flex items-center justify-between px-3 py-1.5
                                    bg-foreground/[0.02] border border-foreground/[0.04]
                                    rounded-lg group hover:border-foreground/[0.08] transition-colors">
                        <div class="flex items-center gap-2">
                            <div class="w-1.5 h-1.5 rounded-full bg-emerald-500/70 flex-shrink-0"></div>
                            <code
                                class="text-[10px] font-bold text-slate-800 dark:text-white/90/60">{{ ctrl.value }}</code>
                        </div>
                        <button type="button" (click)="removePermission(i)" class="opacity-0 group-hover:opacity-100 w-6 h-6 rounded-md
                                         hover:bg-red-500/10 flex items-center justify-center transition-all">
                            <iconify-icon icon="mdi:close" width="13" class="text-red-500/60"></iconify-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="mt-8 space-y-4">
            <!-- Errores de validación -->
            <div *ngIf="form.invalid && form.touched"
                class="flex items-start gap-2 px-3.5 py-2.5 rounded-xl bg-amber-500/5 border border-amber-500/15 animate-fade-in">
                <iconify-icon icon="mdi:alert-circle-outline" width="14"
                    class="text-amber-500 flex-shrink-0 mt-0.5"></iconify-icon>
                <div>
                    <p class="text-[9px] font-black uppercase tracking-widest text-amber-500 mb-1">Campos requeridos</p>
                    <ul class="text-[8px] text-amber-500/70 space-y-0.5 list-disc list-inside">
                        <li *ngIf="form.get('key')?.invalid">Key del módulo — {{ keyError }}</li>
                        <li *ngIf="form.get('label')?.invalid">Nombre del módulo</li>
                        <li *ngIf="form.get('icon')?.invalid">Ícono MDI</li>
                        <li *ngIf="form.get('route')?.invalid">Ruta Angular</li>
                    </ul>
                </div>
            </div>

            <!-- Error de API -->
            <div *ngIf="error()"
                class="flex items-center gap-2 px-4 py-3 rounded-xl bg-red-500/5 border border-red-500/10 animate-shake">
                <iconify-icon icon="mdi:alert-circle-outline" width="16"
                    class="text-red-500 flex-shrink-0"></iconify-icon>
                <p class="text-[10px] font-black uppercase tracking-widest text-red-500">{{ error() }}</p>
            </div>

            <div class="flex items-center justify-end gap-3">
                <app-button (click)="goBack()" variant="outline" size="xs" iconLeft="mdi:cancel"
                    class="h-9 px-6 text-[9px] font-black uppercase">Cancelar</app-button>
                <app-button (click)="save()" [disabled]="saving() || form.invalid" [loading]="saving()" size="xs"
                    variant="primary" class="h-9 px-8 text-[9px] font-black uppercase shadow-lg shadow-primary/20"
                    [iconLeft]="saving() ? 'mdi:loading' : (isEdit() ? 'mdi:content-save-outline' : 'mdi:plus')">
                    {{ isEdit() ? 'Guardar Cambios' : 'Registrar Módulo' }}
                </app-button>
            </div>
        </div>
    </form>
</div>